import Vue from "vue";
import axios from "axios"; // Lecture 346
import {
  FORM_TYPE,
  BUILDER_TYPE,
  BUILDER_USER_TYPE,
  JOB_UPDATE_STATUS_SENT
} from "../constants/custom-define-type";

import { DO_NOT_SHOW_DUPLICATED_DOCUMENTS_SETTINGS } from "../constants/agency-settings/general-settings"

Vue.mixin({
  computed: {},
  methods: {
    async updateUserStatus(user, status, author, isShowResult = true, reason = null) {
      if (author == null) {
        author = user;
      }
      return new Promise(async (resolve, reject) => {
        // Send request to update status
        let res = await axios.post("/set-user-status/", {
          id: user.id,
          status: status
        });
        if (res == null) {
          reject();
        }
        const isEmailSent = await this.handleAfterUserStatusChanged(user, status, author, reason);
        if (isShowResult) {
          this.showResultDialog('STATUS_UPDATED_RESULT_DIALOG');
        }
        resolve(isEmailSent);
      });
    },
    handleAfterUserStatusChanged(user, status, author, reason, isSecondStatus, isInApplicationForm = false) {
      if (author == null) {
        author = user;
      }
      return new Promise(async (resolve, reject) => {
        let selector1 = "";
        if (user.is_candidate) {
          selector1 = "Candidate";
          // Check to send reference check form
          await this.sendCheckFormToUserReferences(user, status);
        } else if (user.is_employer) {
          selector1 = "Client";
        }
        let isEmailSent = false;
        if (!isInApplicationForm) {
          isEmailSent = await this.sendEmailToUserAfterStatusChange(user, author, status, selector1, isSecondStatus);
          await this.sendUserStatusChangeNotificationToAdmin(user, status, isSecondStatus);
        }
        await this.sendEmailStatusChangeNotificationToReferences(user, status);
        await this.sendSMSStatusChangeNotificationToReferences(user, status);
        await this.sendUserStatusChangeNotificationSMS(user, status, isSecondStatus);
        if (!isInApplicationForm) {
          await this.addDocumentAfterStatusChange({ user, status, selector1, isSecondStatus, isShowStatusDialog: false });
          // Get any evaluations templates that trigger on a change to this status
          let res = await axios.get(
            `/api/evaluationtemplates/?agency=${this.$store.getters.agencyID
            }&status_trigger=${encodeURIComponent(status)}&user_type=${selector1}`
          );
          if (res == null) {
            reject();
          }
          const evaluationTemplates = this.filterTemplatesByUserTypes(user, res.data);
          for (const template of evaluationTemplates) {
            await axios.post("/api/evaluations/", {
              name: template.name,
              template: template.id,
              order: template.order,
              user: user.id,
              status: "Not Started",
              agency_owner: this.$store.getters.agencyName,
              agency: this.$store.getters.agencyID
            });
          }

          // Keep track of status changes when a status is updated. -  Posts status change, timestamp and changer.
          const requestBody = {
            user: user.id,
            name: `${user.first_name} ${user.last_name}`,
            changer: author.id,
            changer_name: `${author.first_name} ${author.last_name}`,
            is_candidate: user.is_candidate,
            is_employer: user.is_employer,
            reason: reason ? reason.reason : null,
            reason_note: reason ? reason.note : null,
            agency: this.$store.getters.agencyID,
            agency_owner: this.$store.getters.agencyName
          }
          if (isSecondStatus) {
            requestBody.second_status = status
          } else {
            requestBody.status = status
          }
          res = await axios.post(`/api/statuschanges/`, requestBody);
          if (res == null) {
            reject();
          }
        }
        resolve(isEmailSent);
      });
    },
    sendEmailToUserAfterStatusChange(user, author, status, selector1, isSecondStatus) {
      return new Promise(async (resolve, reject) => {
        const templateType = isSecondStatus ? 'Second Status Change Notification' : 'Status Change Notification';
        // Get the email template corresponding to the new status
        let res = await this.getEmailTemplates(
          `/api/emailtemplates/?agency=${this.$store.getters.agencyID
          }&status=${encodeURIComponent(
            status
          )}&type=${templateType}&selector1=${selector1}&deactivated=false`
        );
        if (res == null || res.data == null) {
          reject();
        }
        let hasSendEmailDialog = false;
        if (res.data.length) {
          // If there is an email template for this new status
          let emailTemplates = res.data;
          const emailTemplate = this.findEmailTemplatesByUserTypes(
            user,
            emailTemplates
          );

          if (emailTemplate) {
            let documentLinks = '';
            // Check to add document template
            if (emailTemplate.list_document_template_ids) {
              const listDocumentLinks = [];
              for (const templateId of emailTemplate.list_document_template_ids) {
                const document = await this.addDocumentToUser(null, user, templateId);
                if (document) {
                  const documentLink = await this.getShareableDocumentUrl(user, document.id);
                  listDocumentLinks.push(`<a href="${documentLink}" _target="blank">${document.title}</a>`);
                }
              }
              documentLinks = listDocumentLinks.join(', ');
            }
            const mapReplaceValues = {
              fname: user.first_name,
              lname: user.last_name,
              email: user.email,
              id: user.id,
              video_recording_link: await this.getPublicVideoRecordingLink(
                user.id
              ),
              recurring_availability_link: await this.getRecurringAvailabilityShareableUrl(
                user.id
              ),
              my_candidates_shareable_link: await this.getMyCandidateShareableUrl(
                user.id
              ),
              document_link: documentLinks,
              document_links: documentLinks
            };
            let subject = this.replaceTagByMap(
              emailTemplate.subject,
              mapReplaceValues
            );
            subject = this.replaceTagValue(subject, user);
            let message = this.replaceTagByMap(
              emailTemplate.body,
              mapReplaceValues
            );
            message = this.replaceTagValue(message, user);
            const emailObject = {
              subject: subject,
              message: message,
              file_urls: emailTemplate.attachment_urls,
              userID: user.id,
              from: this.getEmailSenderFromEmailTemplate(emailTemplate),
              reply: this.getReplyToFromEmailTemplate(emailTemplate),
              cc: emailTemplate.cc,
              bcc: emailTemplate.bcc,
              excludeFooter: emailTemplate.exclude_footer,
              status: status,
              template: emailTemplate,
              mapReplaceValues: mapReplaceValues,
            };
            if (author && author.is_agent) {
              hasSendEmailDialog = true;
              // Want to show the pop up to edit the email before it goes out
              this.showSendEmailDialog({
                ...emailObject,
                destination: user.email,
                secondaryEmail: user.email2,
                logMessage: false,
                onCloseCallback: async () => {
                  resolve(true);
                }
              });
            } else {
              // Send email without popup
              this.sendEmail({
                ...emailObject,
                recipients: [
                  this.$store.getters.enginehireLoggingEmail,
                  user.email
                ],
                isHtml: true
              });
            }
          }
        }
        if (!hasSendEmailDialog) {
          resolve();
        }
      });
    },
    addDocumentAfterStatusChange({ user, status, selector1, isSecondStatus, isShowStatusDialog }) {
      this.$store.dispatch("updateShowStatusDialog", isShowStatusDialog);
      return new Promise(async (resolve, reject) => {
        const statusTriggerKey = isSecondStatus ? 'second_status_trigger' : 'status_trigger';
        // Get any document templates that trigger on a change to this status
        let res = await axios.get(
          `/api/documenttemplates/?agency=${this.$store.getters.agencyID
          }&${statusTriggerKey}=${encodeURIComponent(status)}&type=${selector1}`
        );
        if (res == null) {
          reject();
        }
        let listTemplates = res.data;
        // Filter in case both status and second_status is set
        if (isSecondStatus) {
          listTemplates = listTemplates.filter(template => !template.status_trigger || template.status_trigger === user.status);
        } else {
          listTemplates = listTemplates.filter(template => !template.second_status_trigger || template.second_status_trigger === user.second_status);
        }
        let hasAddDocDialog = false;
        const templates = this.filterTemplatesByUserTypes(user, listTemplates);
        if (templates && templates.length) {
          if (this.$store.getters.isAgent) {
            // Show dialog to let admin select documents to add to user
            let listExistingDocTemplateIds = [];
            if (user.documents) {
              listExistingDocTemplateIds = user.documents.map(document => document.template);
            }
            const mapDisplayedOptions = {};
            // Select non-duplicated items by default
            const listDefaultSelected = [];
            const duplicatedTemplates = [];
            templates.forEach(template => {
              if (listExistingDocTemplateIds.includes(template.id)) {
                mapDisplayedOptions[template.id] = `${template.name} (<b>Duplicated</b>)`;
                duplicatedTemplates.push(template.id);
              } else {
                listDefaultSelected.push(template.id);
                mapDisplayedOptions[template.id] = `${template.name}`;
              }
            });
            hasAddDocDialog = true;
            let templateList = templates;
            if (this.$store.getters.doNotShowDuplicatedDocumentsUpdatingStatus) {
              templateList = templateList.filter(template => !duplicatedTemplates.includes(template.id));
            }
            if (this.tryGet(() => templateList.length)) {
              this.showInputDialog({
                title: "Select Documents",
                listFields: [
                  {
                    label: "Select Documents to Add to the User",
                    type: FORM_TYPE.CHECKBOX,
                    model: "selectedTemplates",
                    optionList: templateList.map(template => template.id),
                    mapDisplayedOptions: mapDisplayedOptions,
                    isHtml: true,
                    isRequired: false,
                    buttonGroups: [
                      {
                        id: "agency-setting",
                        useSmallIcon: true,
                        listSettings: DO_NOT_SHOW_DUPLICATED_DOCUMENTS_SETTINGS,
                        onSubmitCallback: this.addDocumentAfterStatusChange,
                        onSubmitCallbackData: {
                          user,
                          status,
                          selector1,
                          isSecondStatus,
                          isShowStatusDialog: true
                        }
                      },
                    ],
                  },
                ],
                data: {
                  selectedTemplates: listDefaultSelected
                },
                onSubmitCallback: async (info) => {
                  if (info.selectedTemplates) {
                    console.log(templates);
                    const listSelectedTemplates = templates.filter(template => info.selectedTemplates.includes(template.id));
                    console.log(info.selectedTemplates)
                    console.log(listSelectedTemplates);
                    await this.addDocumentsToUser(listSelectedTemplates, user);
                  }
                },
                onCloseCallback: () => {
                  if (!this.$store.getters.showStatusDialog) {
                    resolve();
                  }
                },
              });
              return
            }
            resolve();
          } else {
            await this.addDocumentsToUser(templates, user);
          }
        }
        if (!hasAddDocDialog) {
          resolve();
        }
      });
    },
    async addDocumentToUser(template, user, templateId = null) {
      if (!template) {
        const templateRes = await axios.get(`/api/documenttemplates/${templateId}`);
        if (templateRes && templateRes.data) {
          template = templateRes.data;
        }
      }
      if (!template) {
        return;
      }
      const res = await axios.post("/api/documents/", {
        template: template.id,
        title: template.name,
        signing_user: user.id,
        status: "Unsigned",
        body: template.body,
        fields_labels: template.fields,
        fields_required: template.fields_required,
        list_fields: template.list_fields,
        edit_access: template.edit_access,
        organization_signer: template.organization_signer,
        signer_labels: template.signer_labels,
        signing_notification_emails:
          template.signing_notification_emails,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
        sign_by_both: template.sign_by_both,
        status_to_update_to: template.status_to_update_to,
        signer_types: template.signer_types,
        order: template.order,
        use_image: template.use_image,
        params: template.params,
      });
      if (res && res.data) {
        return res.data;
      }
    },
    addDocumentsToUser(templates, user) {
      return new Promise(async (resolve) => {
        for (const template of templates) {
          await this.addDocumentToUser(template, user);
        }
        if (this.$store.getters.showStatusDialog) {
          this.showResultDialog(this.$store.getters.statusUpdatedResultDialog);
        }
        resolve();
      });
    },
    sendCheckFormToUserReferences(user, status) {
      return new Promise(async resolve => {
        let applicationFormId = user.application_form;
        if (typeof applicationFormId !== "number") {
          applicationFormId = user.application_form_id;
        }
        const listBuilder = this.$store.getters.profileBuilderList.sort(
          (a, b) => a.id - b.id
        );
        let profileBuilder = listBuilder.find(
          builder => builder.id === applicationFormId
        );
        if (!profileBuilder) {
          // Find corresponding profile builder
          profileBuilder = listBuilder.find(
            builder =>
              builder.application_builder_id === applicationFormId &&
              builder.type === BUILDER_TYPE.PROFILE &&
              builder.user_type === BUILDER_USER_TYPE.CANDIDATE
          );
        }

        if (profileBuilder == null) {
          // For old data, which is not set applicaiton_form, no profile builder => use application builder
          profileBuilder = listBuilder.find(
            builder =>
              builder.type === BUILDER_TYPE.APPLICATION &&
              builder.user_type === BUILDER_USER_TYPE.CANDIDATE
          );
        }

        if (profileBuilder == null) {
          // For old data, which is not set applicaiton_form, find one profile builder
          profileBuilder = listBuilder.find(
            builder =>
              builder.type === BUILDER_TYPE.PROFILE &&
              builder.user_type === BUILDER_USER_TYPE.CANDIDATE
          );
        }
        
        if (profileBuilder == null) {
          resolve();
          return;
        }

        const listFields = this.mergeBuilders(profileBuilder, listBuilder, true)
          .listFields;
        if (!listFields) {
          resolve();
          return;
        }
        const listReferenceFields = listFields.filter(
          field =>
            field.referenceCheckFormAutoSend &&
            field.checkFormTriggerStatus === status
        );
        let listReferences = null;
        let listExperiences = null;
        let listData = null;
        for (const referenceField of listReferenceFields) {
          if (referenceField.name === "Experience") {
            if (listExperiences == null) {
              listExperiences = await this.getListExperiences(user);
            }
            listData = listExperiences;
          } else {
            if (listReferences == null) {
              listReferences = await this.getListReferences(user);
            }
            listData = listReferences;
          }
          for (const data of listData) {
            if (this.isMatchField(referenceField, data, listFields)) {
              // Send email
              await this.sendReferenceCheckFormEmail(
                profileBuilder.id,
                data.id,
                referenceField,
                data,
                user
              );
            }
          }
        }
        resolve();
      });
    },
    sendReferenceCheckFormEmail(
      profileBuilderId,
      referenceId,
      referenceField,
      referenceData,
      user
    ) {
      return new Promise(async resolve => {
        // Find the reference check form
        const resHasNum = await axios.post("/hash-num", { id: referenceId });
        if (resHasNum == null || resHasNum.data == null) {
          resolve();
        }
        let checkFormToken;
        if (referenceField.name === "Experience") {
          checkFormToken = "/experience-check-form/";
        } else {
          checkFormToken = "/reference-check-form/";
        }
        const refCheckUrl =
          this.rootUrl +
          checkFormToken +
          profileBuilderId +
          "/" +
          resHasNum.data.key;
        // Get email template if it is set
        let hasEmailTemplate = false;
        if (referenceField.referenceNotificationEmailTemplateId) {
          const res = await axios.get(
            `/api/emailtemplates/${referenceField.referenceNotificationEmailTemplateId}/`
          );
          if (res && res.data) {
            const emailTemplate = res.data;
            let referenceName = referenceData.first_name;
            if (!referenceName) {
              referenceName = referenceData.person_worked_for_name;
            }
            const mapReplaceValues = {
              reference_fname: referenceName,
              user_fname: user.first_name,
              user_lname: user.last_name,
              reference_check_link: refCheckUrl
            };
            if (
              (emailTemplate.subject &&
                emailTemplate.subject.includes("[[user_shareable_link]]")) ||
              (emailTemplate.body &&
                emailTemplate.body.includes("[[user_shareable_link]]"))
            ) {
              const userShareableLink = await this.getShareableURL(user, true);
              mapReplaceValues["user_shareable_link"] = userShareableLink;
            }
            const subject = this.replaceTagByMap(
              emailTemplate.subject,
              mapReplaceValues
            );
            const message = this.replaceTagByMap(
              emailTemplate.body,
              mapReplaceValues
            );
            this.sendEmail({
              subject: subject,
              message: message,
              recipients: [referenceData.email],
              isHtml: true
            });
            hasEmailTemplate = true;
          }
        }
        // Send predefined email template
        if (!hasEmailTemplate) {
          this.sendEmail(
            {
              ...this.$store.getters.referenceCheckFormEmailTemplate,
              recipients: [referenceData.email],
              isHtml: true
            },
            user.first_name,
            user.last_name,
            referenceData.first_name,
            referenceData.last_name,
            refCheckUrl,
            this.$store.getters.agencyPublic.human_name
          );
        }
        resolve();
      });
    },
    // Check if a reference/experience is match with a reference field
    isMatchField(field, data, listFields) {
      if (data.type === field.label) {
        return true;
      }
      // If there is only one reference or one experience field
      if (field.name === "Experience") {
        if (
          listFields.filter(field => field.name === "Experience").length === 1
        ) {
          return true;
        }
      } else {
        if (
          listFields.filter(field => field.name === "Reference").length === 1
        ) {
          return true;
        }
      }
      return false;
    },
    async getListReferences(user) {
      return new Promise(async (resolve, reject) => {
        const res = await axios.get(`/api/references/?user=${user.id}`);
        if (!res) {
          reject();
        }
        resolve(res.data);
      });
    },
    async getListExperiences(user) {
      return new Promise(async (resolve, reject) => {
        const res = await axios.get(`/api/experiences/?user=${user.id}`);
        if (!res) {
          reject();
        }
        resolve(res.data);
      });
    },
    sendUserStatusChangeNotificationToAdmin(user, status, isSecondStatus) {
      return new Promise(async (resolve, reject) => {
        const templateType = isSecondStatus ? 'Second Status Change Notification' : 'Status Change Notification';
        // Get the email template corresponding to the new status
        let res = await this.getEmailTemplates(
          `/api/emailtemplates/?agency=${this.$store.getters.agencyID
          }&status=${encodeURIComponent(
            status
          )}&type=${templateType}&selector1=Admin&deactivated=false`
        );
        if (res == null || res.data == null) {
          reject();
        }
        let hasEmailPopup = false;
        if (res.data.length) {
          // If there is an email template for this new status
          let emailTemplates = res.data;
          const emailTemplate = this.findEmailTemplatesByUserTypes(
            user,
            emailTemplates
          );

          let candidateShareableLink = null;
          let clientShareableLink = null;
          if (user.is_candidate) {
            candidateShareableLink = await this.getShareableURL(
              user,
              true
            );
          }
          if (user.is_employer) {
            clientShareableLink = await this.getShareableURL(
              user,
              false
            );
          }

          if (emailTemplate) {
            const mapReplaceValues = {
              fname: user.first_name,
              lname: user.last_name,
              email: user.email,
              id: user.id,
              candidate_shareable_link: candidateShareableLink || '',
              client_shareable_link: clientShareableLink || ''
            };
            const subject = this.replaceTagByMap(
              emailTemplate.subject,
              mapReplaceValues
            );
            const message = this.replaceTagByMap(
              emailTemplate.body,
              mapReplaceValues
            );
            const emailObject = {
              subject: subject,
              message: message,
              file_urls: emailTemplate.attachment_urls,
              userID: user.id,
              from: this.getEmailSenderFromEmailTemplate(emailTemplate),
              reply: this.getReplyToFromEmailTemplate(emailTemplate),
              cc: emailTemplate.cc,
              bcc: emailTemplate.bcc,
              excludeFooter: emailTemplate.exclude_footer,
              status: status,
              template: emailTemplate,
              mapReplaceValues: mapReplaceValues,
            };
            if (this.$store.getters.isAgent) {
              hasEmailPopup = true;
              // Send email with popup
              this.showSendEmailDialog({
                ...emailObject,
                destination: emailTemplate.destinations.join(';'),
                secondaryEmail: user.email2,
                logMessage: true,
                onCloseCallback: async () => {
                  resolve(true);
                }
              });
            } else {
              // Send email without popup
              this.sendEmail({
                ...emailObject,
                recipients: [
                  this.$store.getters.enginehireLoggingEmail,
                  ...emailTemplate.destinations
                ],
                logMessage: true,
                isHtml: true,
              });

            }
          }
        }
        if (!hasEmailPopup) {
          resolve();
        }
      });
    },
    sendEmailStatusChangeNotificationToReferences(user, status) {
      return new Promise(async (resolve, reject) => {
        const templateType = 'Status Change Notification';
        const userType = user.is_candidate ? 'Candidate' : 'Client';
        // Get the email template corresponding to the new status
        let res = await this.getEmailTemplates(
          `/api/emailtemplates/?agency=${this.$store.getters.agencyID
          }&status=${encodeURIComponent(
            status
          )}&type=${templateType}&selector1=Reference&selector3=${userType}&deactivated=false`
        );
        if (res == null || res.data == null) {
          reject();
        }
        if (res.data.length) {
          // If there is an email template for this new status
          let emailTemplates = res.data;
          const emailTemplate = this.findEmailTemplatesByUserTypes(
            user,
            emailTemplates
          );

          if (emailTemplate) {
            const listReferences = await this.getListReferences(user);
            for (const reference of listReferences) {
              const mapReplaceValues = {
                fname: user.first_name,
                lname: user.last_name,
                email: user.email,
                id: user.id,
                reference_fname: reference.first_name,
                reference_lname: reference.last_name
              };
              await this.sendEmailToUser(reference, emailTemplate, mapReplaceValues, status);
            }

          }
        }
        resolve();
      });
    },
    sendSMSStatusChangeNotificationToReferences(user, status) {
      return new Promise(async (resolve, reject) => {
        const templateType = 'Status Change Notification';
        const userType = user.is_candidate ? 'Candidate' : 'Client';
        // Get the email template corresponding to the new status
        let res = await this.getEmailTemplates(
          `/api/smstemplates/?agency=${this.$store.getters.agencyID
          }&status=${encodeURIComponent(
            status
          )}&type=${templateType}&selector1=Reference&selector3=${userType}&deactivated=false`
        );
        if (res == null || res.data == null) {
          reject();
        }
        if (res.data.length) {
          // If there is an email template for this new status
          const emailTemplate = this.findEmailTemplatesByUserTypes(
            user,
            res.data
          );
          if (emailTemplate) {
            const listReferences = await this.getListReferences(user);
            for (const reference of listReferences) {
              const mapReplaceValues = {
                fname: user.first_name,
                lname: user.last_name,
                email: user.email,
                id: user.id,
                reference_fname: reference.first_name,
                reference_lname: reference.last_name
              };
              await this.sendSMSToUser(reference, emailTemplate, mapReplaceValues, user);
            }
          }
        }
        resolve();
      });
    },
    // General function to send email to client, candidate, admin, reference,
    async sendEmailToUser(user, emailTemplate, mapReplaceValues, status) {
      if (!user.email) {
        return;
      }
      return new Promise(async (resolve) => {
        const subject = this.replaceTagByMap(
          emailTemplate.subject,
          mapReplaceValues
        );
        const message = this.replaceTagByMap(
          emailTemplate.body,
          mapReplaceValues
        );
        const emailObject = {
          subject: subject,
          message: message,
          file_urls: emailTemplate.attachment_urls,
          userID: user.id,
          from: this.getEmailSenderFromEmailTemplate(emailTemplate),
          reply: this.getReplyToFromEmailTemplate(emailTemplate),
          cc: emailTemplate.cc,
          bcc: emailTemplate.bcc,
          excludeFooter: emailTemplate.exclude_footer,
          status: status,
          template: emailTemplate,
          mapReplaceValues: mapReplaceValues,
        };
        if (this.$store.getters.isAgent) {
          // Send email with popup
          this.showSendEmailDialog({
            ...emailObject,
            destination: user.email,
            secondaryEmail: user.email2,
            logMessage: true,
            onCloseCallback: async () => {
              resolve();
            }
          });
        } else {
          // Send email without popup
          this.sendEmail({
            ...emailObject,
            recipients: [
              user.email
            ],
            logMessage: true,
            isHtml: true,
          });
          resolve();
        }
      });
    },
    async sendSMSMessageToUser(user, message) {
      if (!user.phone) {
        return;
      }
      return new Promise(async (resolve) => {
        if (this.$store.getters.isAgent) {
          this.showInputDialog({
            title: "Send SMS Notification",
            listFields: [
              {
                label: "Phone",
                type: FORM_TYPE.LABEL,
                model: user.phone
              },
              {
                label: "Message",
                type: FORM_TYPE.TEXTAREA,
                model: "message",
                isCounter: true
              },
            ],
            data: {
              message: message
            },
            submitLabel: "Send",
            onSubmitCallback: async (SMSInfo) => {
              await axios.post("/optimum/message/", {
                message: SMSInfo.message,
                phone: user.phone,
                user_id: user.id,
                from_phone: this.$store.getters.agency.twilio_phone_number
                  ? this.$store.getters.agency.twilio_phone_number
                  : "",
                agency_id: this.$store.getters.agencyID,
                log: true
              });
            },
            onCloseCallback: () => {
              resolve();
            }
          });
        } else {
          await axios.post("/optimum/message/", {
            message: message,
            phone: user.phone,
            user_id: user.id,
            from_phone: this.$store.getters.agency.twilio_phone_number
              ? this.$store.getters.agency.twilio_phone_number
              : "",
            agency_id: this.$store.getters.agencyID,
            log: true
          });
          resolve();
        }
      })
    },
    async sendSMSToUser(user, template, mapReplacedValues, tagInfo) {
      if (!user.phone) {
        return;
      }
      return new Promise(async (resolve) => {
        let initialSMSMessage = this.replaceTagByMap(
          template.message,
          mapReplacedValues
        );
        initialSMSMessage = this.replaceTagValue(initialSMSMessage, tagInfo);
        await this.sendSMSMessageToUser(user, initialSMSMessage);
        resolve();
      })
    },
    sendJobSMSNotification(smsTemplate, job, client, candidate, target) {
      if (!target.phone) {
        return;
      }
      return new Promise(async resolve => {
        if (smsTemplate) {
          const initialSMSMessage = await this.makeJobStringSubstitutions(
            smsTemplate.message,
            job,
            client,
            candidate
          );
          await this.sendSMSMessageToUser(target, initialSMSMessage);
          resolve();
        } else {
          resolve();
        }
      });
    },
    async handleAfterBulkJobStatusChange(listJobs, status) {
      return new Promise(async (resolve, reject) => {
        // Get the email template corresponding to the new status
        let res = await this.getEmailTemplates(
          `/api/emailtemplates/?agency=${this.$store.getters.agencyID
          }&status=${encodeURIComponent(
            status
          )}&type=Status Change Notification&selector1=Job&deactivated=false`
        );
        if (res == null || res.data == null) {
          reject();
        }
        if (res.data.length) {
          const listDates = listJobs
            .map((job) => this.getDateString(job.date))
            .join(", ");
          const listDatesCompressed = listJobs
            .map((job) => this.compressDateFormat(job.date))
            .join(", ");
          const jobIds = listJobs.map((job) => job.id).join(", ");
          const jobLinks = listJobs.map(job => `${this.rootUrl}/job/${job.id}`).join(', ');
          const mapReplaceValues = {
            jobdates: listDates,
            jobdates_compressed: listDatesCompressed,
            jobdatestimes: this.getJobsDatesTimes(listJobs),
            jobdatestimes_compressed: this.getJobsDatesTimesCompressed(listJobs),
            jobids: jobIds,
            joblinks: jobLinks
          }
          const listUserEmails = [];
          const listUserEmailsContent = [];
          // If there is an email template for this new status
          let emailTemplates = res.data;
          const listPosterEmailTemplates = emailTemplates.filter(template => template.selector2 === "Job Poster")
          const listFillerEmailTemplates = emailTemplates.filter(template => template.selector2 === "Job Filler")
          for (const aJob of listJobs) {
            const job = await this.$store.dispatch('getJobFullInfo', aJob);
            // Send email to poster
            let client;
            if (job.poster) {
              res = await axios.get(`/api/people/?id=${job.poster}`);
              if (res && res.data && res.data.length) {
                client = res.data[0];
              }
            }
            if (this.$store.getters.multipleFillersShiftJob) {
              let listFillers = await this.$store.dispatch('getFillersOfJob', job);
              if (client) {
                const posterEmailTemplate = this.findEmailTemplatesByUserTypes(client, listPosterEmailTemplates, job, client, listFillers.length ? listFillers[0] : {})
                if (posterEmailTemplate) {
                  const subject = await this.makeJobStringSubstitutions(
                    this.replaceTagByMap(posterEmailTemplate.subject, mapReplaceValues),
                    job,
                    client,
                    listFillers.length ? listFillers[0] : {},
                  );
                  const message = await this.makeJobStringSubstitutions(
                    this.replaceTagByMap(posterEmailTemplate.body, mapReplaceValues),
                    job,
                    client,
                    listFillers.length ? listFillers[0] : {},
                  );
                  const content = client.id + '-' + subject + message;
                  if (!listUserEmailsContent.includes(content)) {
                    listUserEmailsContent.push(content);
                    listUserEmails.push({
                      subject: subject,
                      message: message,
                      template: posterEmailTemplate,
                      user: client
                    })
                  }
                }
              }
              // Send email to filler
              if (listFillers.length) {
                for (const candidate of listFillers) {
                  const fillerEmailTemplate = this.findEmailTemplatesByUserTypes(candidate, listFillerEmailTemplates, job, client || {}, candidate || {})
                  if (fillerEmailTemplate) {
                    const subject = await this.makeJobStringSubstitutions(
                      this.replaceTagByMap(fillerEmailTemplate.subject, mapReplaceValues),
                      job,
                      client,
                      candidate
                    );
                    const message = await this.makeJobStringSubstitutions(
                      this.replaceTagByMap(fillerEmailTemplate.body, mapReplaceValues),
                      job,
                      client,
                      candidate
                    );
                    const content = candidate.id + '-' + subject + message;
                    if (!listUserEmailsContent.includes(content)) {
                      listUserEmailsContent.push(content);
                      listUserEmails.push({
                        subject: subject,
                        message: message,
                        template: fillerEmailTemplate,
                        user: candidate
                      })
                    }
                  }
                }
              }
            } else {
              let candidate;
              if (job.filler) {
                res = await axios.get(`/api/people/?id=${job.filler}`);
                if (res && res.data && res.data.length) {
                  candidate = res.data[0];
                }
              }
              if (client) {
                const posterEmailTemplate = this.findEmailTemplatesByUserTypes(client, listPosterEmailTemplates, job, client, candidate || {})
                if (posterEmailTemplate) {
                  const subject = await this.makeJobStringSubstitutions(
                    this.replaceTagByMap(posterEmailTemplate.subject, mapReplaceValues),
                    job,
                    client,
                    candidate
                  );
                  const message = await this.makeJobStringSubstitutions(
                    this.replaceTagByMap(posterEmailTemplate.body, mapReplaceValues),
                    job,
                    client,
                    candidate
                  );
                  const content = client.id + '-' + subject + message;
                  if (!listUserEmailsContent.includes(content)) {
                    listUserEmailsContent.push(content);
                    listUserEmails.push({
                      subject: subject,
                      message: message,
                      template: posterEmailTemplate,
                      user: client
                    })
                  }
                }
              }
              // Send email to filler
              if (candidate) {
                const fillerEmailTemplate = this.findEmailTemplatesByUserTypes(candidate, listFillerEmailTemplates, job, client || {}, candidate || {})
                if (fillerEmailTemplate) {
                  const subject = await this.makeJobStringSubstitutions(
                    this.replaceTagByMap(fillerEmailTemplate.subject, mapReplaceValues),
                    job,
                    client,
                    candidate
                  );
                  const message = await this.makeJobStringSubstitutions(
                    this.replaceTagByMap(fillerEmailTemplate.body, mapReplaceValues),
                    job,
                    client,
                    candidate
                  );
                  const content = candidate.id + '-' + subject + message;
                  if (!listUserEmailsContent.includes(content)) {
                    listUserEmailsContent.push(content);
                    listUserEmails.push({
                      subject: subject,
                      message: message,
                      template: fillerEmailTemplate,
                      user: candidate
                    })
                  }
                }
              }
            }
          }
          if (listUserEmails.length) {
            for (const userEmail of listUserEmails) {
              await this.sendEmailToJobUser(userEmail);
            }
          }
        }
        await this.sendSMSBulkJobStatusChange(listJobs, status);
        resolve();
      });
    },
    async sendSMSBulkJobStatusChange(listJobs, status) {
      return new Promise(async (resolve, reject) => {
        // Get the sms template corresponding to the new status
        let res = await axios.get(
          `/api/smstemplates/?agency=${this.$store.getters.agencyID
          }&status=${encodeURIComponent(
            status
          )}&type=Status Change Notification&selector1=Job&deactivated=false`
        );
        if (res == null || res.data == null) {
          reject();
        }
        if (res.data.length) {
          // If there is an sms template for this new status
          let smsTemplates = res.data;
          const listPosterSmsTemplates = smsTemplates.filter(template => template.selector2 === "Job Poster")
          const listFillerSmsTemplates = smsTemplates.filter(template => template.selector2 === "Job Filler")
          for (const aJob of listJobs) {
            const job = await this.$store.dispatch('getJobFullInfo', aJob);
            // Send sms to poster
            let client;
            if (job.poster) {
              res = await axios.get(`/api/people/?id=${job.poster}`);
              if (res && res.data && res.data.length) {
                client = res.data[0];
              }
            }
            if (this.$store.getters.multipleFillersShiftJob) {
              let listFillers = await this.$store.dispatch('getFillersOfJob', job);
              if (client) {
                const posterSmsTemplate = this.findEmailTemplatesByUserTypes(client, listPosterSmsTemplates, job, client, listFillers.length ? listFillers[0] : {})
                if (posterSmsTemplate) {
                  await this.sendJobSMSNotification(
                    posterSmsTemplate,
                    job,
                    client,
                    listFillers.length ? listFillers[0] : {},
                    client
                  );
                }
              }
              // Send sms to filler
              if (listFillers.length) {
                for (const candidate of listFillers) {
                  const fillerSmsTemplate = this.findEmailTemplatesByUserTypes(candidate, listFillerSmsTemplates, job, client || {}, candidate || {})
                  if (fillerSmsTemplate) {
                    await this.sendJobSMSNotification(
                      fillerSmsTemplate,
                      job,
                      client,
                      candidate,
                      candidate
                    );
                  }
                }
              }
            } else {
              let candidate;
              if (job.filler) {
                res = await axios.get(`/api/people/?id=${job.filler}`);
                if (res && res.data && res.data.length) {
                  candidate = res.data[0];
                }
              }
              if (client) {
                const posterSmsTemplate = this.findEmailTemplatesByUserTypes(client, listPosterSmsTemplates, job, client || {}, candidate || {})
                if (posterSmsTemplate) {
                  await this.sendJobSMSNotification(
                    posterSmsTemplate,
                    job,
                    client,
                    candidate,
                    client
                  );
                }
              }
              // Send sms to filler
              if (candidate) {
                const fillerSmsTemplate = this.findEmailTemplatesByUserTypes(candidate, listFillerSmsTemplates, job, client || {}, candidate || {})
                if (fillerSmsTemplate) {
                  await this.sendJobSMSNotification(
                    fillerSmsTemplate,
                    job,
                    client,
                    candidate,
                    candidate
                  );
                }
              }
            }
          }
        }
        resolve();
      });
    },
    sendSMSJobStatusChangeNotification(job, client, listFillers, status) {
      return new Promise(async (resolve, reject) => {
        // Get sms template corresponding to the new status
        let res = await axios.get(
          `/api/smstemplates/?agency=${this.$store.getters.agencyID
          }&status=${encodeURIComponent(
            status
          )}&type=Status Change Notification&selector1=Job&deactivated=false`
        );
        if (res == null || res.data == null) {
          reject();
        }
        let isSentPoster = false;
        let isSentFiller = false;
        if (res.data.length) {
          // If there is an email template for this new status
          let smsTemplates = res.data;
          const listPosterSmsTemplates = smsTemplates.filter(template => template.selector2 === "Job Poster")
          const listFillerSmsTemplates = smsTemplates.filter(template => template.selector2 === "Job Filler")
          // Send sms to poster
          const posterSmsTemplate = this.findEmailTemplatesByUserTypes(client, listPosterSmsTemplates, job, client, listFillers.length ? listFillers[0] : {})
          if (posterSmsTemplate) {
            await this.sendJobSMSNotification(
              posterSmsTemplate,
              job,
              client,
              listFillers.length ? listFillers[0] : {},
              client
            );
            isSentPoster = true;
          }
          // Send sms to filler
          if (listFillers.length) {
            for (const candidate of listFillers) {
              const fillerSmsTemplate = this.findEmailTemplatesByUserTypes(candidate, listFillerSmsTemplates, job, client || {}, candidate || {})
              if (fillerSmsTemplate) {
                await this.sendJobSMSNotification(
                  fillerSmsTemplate,
                  job,
                  client,
                  candidate,
                  candidate
                );
              }
            }
            isSentFiller = true;
          }
        }

        let returnCode = JOB_UPDATE_STATUS_SENT.NONE;
        if (isSentPoster) {
          if (isSentFiller) {
            returnCode = JOB_UPDATE_STATUS_SENT.POSTER_FILLER;
          } else {
            returnCode = JOB_UPDATE_STATUS_SENT.POSTER;
          }
        } else {
          if (isSentFiller) {
            returnCode = JOB_UPDATE_STATUS_SENT.FILLER;
          } else {
            returnCode = JOB_UPDATE_STATUS_SENT.NONE;
          }
        }
        resolve(returnCode);
      });
    },
    getListFillerOfJob(job, candidates = []) {
      return new Promise(async (resolve) => {
        if (job.filler) {
          const candidate = candidates.find(candidate => candidate.id === job.filler);
          if (candidate) {
            resolve([candidate]);
            return;
          }
          const resPeople = await axios.get(
            `/api/people/${job.filler}/`
          );
          if (resPeople && resPeople.data) {
            resolve([resPeople.data]);
            return;
          }
        }
        if (this.$store.getters.multipleFillersShiftJob) {
          if (job.fillers && job.fillers.length) {
            const listFillers = candidates.filter(candidate => job.fillers.includes(candidate.id));
            if (listFillers && listFillers.length) {
              resolve(listFillers || []);
              return;
            }
          }
          let listFillers = await this.$store.dispatch('getFillersOfJob', job);
          resolve(listFillers || []);
          return;
        }

        resolve([]);
      });
    },
    async unassignShiftJobAndNotification(job, client, fillerId) {
      // Find the email, or SMS templates
      let res = await this.getEmailTemplates(
        `/api/emailtemplates/?agency=${this.$store.getters.agencyID
        }&type=Shift Job Unassigned Candidate Notification&selector1=Job&deactivated=false`
      );
      let listEmailTemplates = [];
      if (res && res.data) {
        listEmailTemplates = res.data;
      }

      res = await axios.get(
        `/api/smstemplates/?agency=${this.$store.getters.agencyID
        }&type=Shift Job Unassigned Candidate Notification&selector1=Job&deactivated=false`
      );
      let listSMSTemplates = [];
      if (res && res.data) {
        listSMSTemplates = res.data;
      }
      let listFillers = [];
      if (listEmailTemplates.length || listSMSTemplates.length) {
        if (!client) {
          if (job.poster) {
            res = await axios.get(`/api/people/${job.poster}/`);
            if (res && res.data) {
              client = res.data;
            }
          }
        }
        if (this.$store.getters.multipleFillersShiftJob) {
          listFillers = await this.$store.dispatch('getFillersOfJob', job);
          // Check for the case only unassign one filler (not all)
          if (fillerId) {
            listFillers = listFillers.filter(filler => filler.id === fillerId);
          }
        } else {
          if (!fillerId) {
            fillerId = job.filler;
          }
          res = await axios.get(`/api/people/${fillerId}/`);
          if (res && res.data) {
            listFillers.push(res.data);
          }
        }
      }

      await this.$store.dispatch('unassignShiftJob', { job: job, fillerId: fillerId });
      // Send email/sms templates
      if (listFillers.length) {
        if (listEmailTemplates.length) {
          for (const candidate of listFillers) {
            const emailTemplate = this.findEmailTemplatesByUserTypes(candidate, listEmailTemplates, job, client || {}, candidate || {})
            if (emailTemplate) {
              await this.sendJobEmailNotification(
                emailTemplate,
                job,
                client,
                candidate,
                candidate
              );
            }
          }
        }
        if (listSMSTemplates.length) {
          for (const candidate of listFillers) {
            const smsTemplate = this.findEmailTemplatesByUserTypes(candidate, listSMSTemplates, job, client || {}, candidate || {})
            if (smsTemplate) {
              await this.sendJobSMSNotification(
                smsTemplate,
                job,
                client,
                candidate,
                candidate
              );
            }
          }
        }
      }

    },
    sendEmailJobStatusChangeNotification(job, client, listFillers, status) {
      return new Promise(async (resolve) => {
        // Get the email template corresponding to the new status
        let res = await this.getEmailTemplates(
          `/api/emailtemplates/?agency=${this.$store.getters.agencyID
          }&status=${encodeURIComponent(
            status
          )}&type=Status Change Notification&selector1=Job&deactivated=false`
        );
        if (res == null || res.data == null) {
          reject();
        }
        let isSentPoster = false;
        let isSentFiller = false;
        if (res.data.length) {
          // If there is an email template for this new status
          let emailTemplates = res.data;
          const listPosterEmailTemplates = emailTemplates.filter(template => template.selector2 === "Job Poster");
          const listFillerEmailTemplates = emailTemplates.filter(template => template.selector2 === "Job Filler");
          // Send email to poster
          const posterEmailTemplate = this.findEmailTemplatesByUserTypes(client, listPosterEmailTemplates, job, client, listFillers.length ? listFillers[0] : {})
          if (posterEmailTemplate) {
            await this.sendJobEmailNotification(
              posterEmailTemplate,
              job,
              client,
              listFillers.length ? listFillers[0] : {},
              client
            );
            isSentPoster = true;
          }
          // Send email to filler
          if (listFillers.length) {
            for (const candidate of listFillers) {
              const fillerEmailTemplate = this.findEmailTemplatesByUserTypes(candidate, listFillerEmailTemplates, job, client || {}, candidate || {})
              if (fillerEmailTemplate) {
                await this.sendJobEmailNotification(
                  fillerEmailTemplate,
                  job,
                  client,
                  candidate,
                  candidate
                );
                isSentFiller = true;
              }
            }
          }
        }
        // Find return code
        let returnCode = JOB_UPDATE_STATUS_SENT.NONE;
        if (isSentPoster) {
          if (isSentFiller) {
            returnCode = JOB_UPDATE_STATUS_SENT.POSTER_FILLER;
          } else {
            returnCode = JOB_UPDATE_STATUS_SENT.POSTER;
          }
        } else {
          if (isSentFiller) {
            returnCode = JOB_UPDATE_STATUS_SENT.FILLER;
          } else {
            returnCode = JOB_UPDATE_STATUS_SENT.NONE;
          }
        }

        resolve(returnCode);

      });
    },
    sendEmailNotificationToFillerOnCancelJob(job, client, listFillers, reason) {
      return new Promise(async (resolve) => {
        if (this.$store.getters.sendEmailtoCandidateWhenJobIsCancelled) {
          for (const candidate of listFillers) {
            this.sendEmail(
              {
                ...this.$store.getters
                  .jobBookingCancelledFillerNotificationEmailTemplate,
                recipients: [candidate.email],
                userID: candidate.id,
              },
              new Date(job.date + "T00:00:00").toDateString(),
              client.first_name,
              client.last_name,
              client.email,
              job.start_time
                ? this.convertTimeAMPMToString(job.start_time)
                : "Unspecified Start Time",
              job.end_time
                ? this.convertTimeAMPMToString(job.end_time)
                : "Unspecified End Time",
              reason
            );
          }
        }
        resolve();
      })
    },
    sendSMSNotificationToFillerOnCancelJob(job, client, listFillers, reason) {
      return new Promise(async (resolve) => {
        if (this.$store.getters.sendSMStoCandidateWhenJobIsCancelled) {
          const message = this.formatContent(
            this.$store.getters.jobBookingCancelledFillerSMSTemplate
              .message,
            new Date(job.date + "T00:00:00").toDateString(),
            client.first_name,
            client.last_name,
            client.email,
            job.start_time
              ? this.convertTimeAMPMToString(job.start_time)
              : "Unspecified Start Time",
            job.end_time
              ? this.convertTimeAMPMToString(job.end_time)
              : "Unspecified End Time",
            reason
          );
          for (const candidate of listFillers) {
            if (candidate.phone) {
              this.$store.dispatch("sendSMS", {
                textMessage: message + this.smsFooter,
                phone: candidate.phone,
                id: candidate.id,
                from_phone: this.$store.getters.agency.twilio_phone_number,
              });
            }
          }
        }
        resolve();
      })
    },
    notifyApplicantOnCancelJob(job, client, reason) {
      return new Promise(async (resolve) => {
        let recipients = job.applicants
          .map((applicant) => applicant.email)
          .filter((email) => email);
        if (this.tryGet(() => recipients.length)) {
          if (this.$store.getters.sendEmailtoCandidateWhenJobIsCancelled) {
            this.sendEmail(
              {
                ...this.$store.getters
                  .jobBookingCancelledFillerNotificationEmailTemplate,
                recipients,
              },
              new Date(job.date + "T00:00:00").toDateString(),
              client.first_name,
              client.last_name,
              client.email,
              job.start_time
                ? this.convertTimeAMPMToString(job.start_time)
                : "Unspecified Start Time",
              job.end_time
                ? this.convertTimeAMPMToString(job.end_time)
                : "Unspecified End Time",
              reason
            );
          }
        }
        resolve();
      });
    },
    handleAfterJobStatusChanged(aJob, client, candidates, status, reason = '') {
      return new Promise(async (resolve, reject) => {
        let job = aJob;
        if (job.id) {
          job = await this.$store.dispatch('getJobFullInfo', aJob);
        }

        let listFillers = await this.getListFillerOfJob(job, candidates);
        // Send Email notification
        const emailSentCode = await this.sendEmailJobStatusChangeNotification(job, client, listFillers, status);
        // Send SMS notification
        const smsSentCode = await this.sendSMSJobStatusChangeNotification(job, client, listFillers, status);

        if (status === 'Cancelled') {
          // Check to send email and SMS to filler
          if (listFillers.length) {
            if (![
              JOB_UPDATE_STATUS_SENT.FILLER,
              JOB_UPDATE_STATUS_SENT.POSTER_FILLER,
            ].includes(emailSentCode)) {
              await this.sendEmailNotificationToFillerOnCancelJob(job, client, listFillers, reason);
            }
            if (![
              JOB_UPDATE_STATUS_SENT.FILLER,
              JOB_UPDATE_STATUS_SENT.POSTER_FILLER,
            ].includes(smsSentCode) && this.$store.getters.agency.twilio_phone_number) {
              await this.sendSMSNotificationToFillerOnCancelJob(job, client, listFillers, reason);
            }
          } else if (this.$store.getters.notifyAllApplicants && this.tryGet(() => job.applicants.length)) {
            // Notify applicant
            await this.notifyApplicantOnCancelJob(job, client, reason);
          }
        }
        resolve({
          sms: smsSentCode,
          email: emailSentCode
        });
      });
    },
    sendEmailToJobUser({ subject, message, template, user }) {
      const emailTemplate = template;
      const target = user;
      return new Promise(async resolve => {
        const emailObject = {
          subject: subject,
          message: message,
          file_urls: emailTemplate.attachment_urls,
          userID: target.id,
          from: this.getEmailSenderFromEmailTemplate(emailTemplate),
          reply: this.getReplyToFromEmailTemplate(emailTemplate),
          cc: emailTemplate.cc,
          bcc: emailTemplate.bcc,
          excludeFooter: emailTemplate.exclude_footer,
          template: emailTemplate,
        };
        if (this.$store.getters.isAgent) {
          setTimeout(() => {
            // Want to show the pop up to edit the email before it goes out
            this.showSendEmailDialog({
              ...emailObject,
              destination: target.email,
              secondaryEmail: target.email2,
              logMessage: false,
              onCloseCallback: () => {
                resolve();
              }
            });
          }, 10);
        } else {
          // Send email without popup
          this.sendEmail({
            ...emailObject,
            recipients: [
              target.email
            ],
            isHtml: true
          });
          resolve();
        }
      });
    },
    sendJobEmailNotification(emailTemplate, job, client, candidate, target) {
      return new Promise(async resolve => {
        if (emailTemplate) {
          const emailObject = {
            subject: await this.makeJobStringSubstitutions(
              emailTemplate.subject,
              job,
              client,
              candidate
            ),
            message: await this.makeJobStringSubstitutions(
              emailTemplate.body,
              job,
              client,
              candidate
            ),
            file_urls: emailTemplate.attachment_urls,
            userID: target.id,
            from: this.getEmailSenderFromEmailTemplate(emailTemplate),
            reply: this.getReplyToFromEmailTemplate(emailTemplate),
            cc: emailTemplate.cc,
            bcc: emailTemplate.bcc,
            excludeFooter: emailTemplate.exclude_footer,
            template: emailTemplate,
            replaceFunc: this.makeJobStringSubstitutions,
            replaceParams: [job, client, candidate],
          };
          if (this.$store.getters.isAgent) {
            setTimeout(() => {
              // Want to show the pop up to edit the email before it goes out
              this.showSendEmailDialog({
                ...emailObject,
                destination: target.email,
                secondaryEmail: target.email2,
                logMessage: false,
                onCloseCallback: () => {
                  resolve();
                }
              });
            }, 10);
          } else {
            // Send email without popup
            this.sendEmail({
              ...emailObject,
              recipients: [
                this.$store.getters.enginehireLoggingEmail,
                target.email
              ],
              isHtml: true
            });
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    filterTemplatesByMatchingConditions(listTemplates, job, client, candidate) {
      if (!listTemplates) {
        return [];
      }
      return listTemplates.filter(template => {
        if (!template.advance_matching_conditions || !template.advance_matching_conditions) {
          return true;
        }
        let mapTypeObject = {};
        if (job) {
          mapTypeObject = {
            Job: job || {},
            Candidate: candidate || {},
            Client: client || {}
          }
        } else {
          mapTypeObject = {
            Candidate: client || candidate,
            Client: client || candidate,
          }
        }
        for (const condition of template.advance_matching_conditions) {
          const object = mapTypeObject[condition.type];
          if (object && condition.value && condition.value.length) {
            const value = object[condition.model];
            if (Array.isArray(value)) {
              if (!this.hasCommonElement(value, condition.value)) {
                return false;
              }
            } else if (value) {
              if (!condition.value.includes(value)) {
                return false;
              }
            } else {
              return false;
            }
          }
        }
        template.matchingIndex += template.advance_matching_conditions.length * 0.1;
        return true;
      });
    },
    filterTemplatesByUserTypes(user, listTemplates, job, client, candidate) {
      if (listTemplates == null) {
        return [];
      }
      // Use matching index to specify priority
      // If there are multiple matching templates, but only pick one, pick the one with the highest matching index
      listTemplates.forEach(template => {
        template.matchingIndex = 0;
      });

      // Filter by advance_matching_conditions
      if (job) {
        listTemplates = this.filterTemplatesByMatchingConditions(listTemplates, job, client, candidate);
      } else {
        listTemplates = this.filterTemplatesByMatchingConditions(listTemplates, job, user);
      }

      // Filter list templates by locations
      if (user.locations == null || user.locations.length === 0) {
        listTemplates = listTemplates.filter(
          template =>
            template.locations == null || template.locations.length === 0
        );
      } else {
        listTemplates = listTemplates.filter(
          template =>
            template.locations == null ||
            template.locations.length === 0 ||
            this.hasCommonElement(user.locations, template.locations)
        );
        // Template with matching locations > template without locations
        listTemplates.forEach(template => {
          if (template.locations && template.locations.length) {
            template.matchingIndex += 1;
          }
        });
      }
      // Filter list templates by languages
      if (!user.language) {
        listTemplates = listTemplates.filter(
          template =>
            template.languages == null || template.languages.length === 0
        );
      } else {
        listTemplates = listTemplates.filter(
          template =>
            template.languages == null ||
            template.languages.length === 0 ||
            template.languages.includes(user.language)
        );
        // Template with matching languages > template without languages
        listTemplates.forEach(template => {
          if (template.languages && template.languages.length) {
            template.matchingIndex += 1;
          }
        });
      }
      // Filter list templates by marketing_source
      if (!user.marketing_source) {
        listTemplates = listTemplates.filter(
          template =>
            template.marketing_sources == null || template.marketing_sources.length === 0
        );
      } else {
        listTemplates = listTemplates.filter(
          template =>
            template.marketing_sources == null ||
            template.marketing_sources.length === 0 ||
            template.marketing_sources.includes(user.marketing_source)
        );
        // Template with matching languages > template without languages
        listTemplates.forEach(template => {
          if (template.marketing_sources && template.marketing_sources.length) {
            template.matchingIndex += 1;
          }
        });
      }
      if (user.types == null || user.types.length === 0) {
        return listTemplates.filter(
          template =>
            template.user_types == null || template.user_types.length === 0
        );
      }
      // Accept case: user types is not empty, and type of template = empty
      listTemplates = listTemplates.filter(
        template =>
          template.user_types == null ||
          template.user_types.length === 0 ||
          this.hasCommonElement(user.types, template.user_types)
      );
      // Template with matching user types > template without user types
      listTemplates.forEach(template => {
        if (template.user_types && template.user_types.length) {
          template.matchingIndex += 1;
        }
      });
      return listTemplates;
    },
    filterDocumentByUserTypesAndTags(user, listFiles) {
      if (listFiles == null) {
        return [];
      }
      // Filter list files by locations
      if (user.locations == null || user.locations.length === 0) {
        listFiles = listFiles.filter(
          file => file.locations == null || file.locations.length === 0
        );
      } else {
        listFiles = listFiles.filter(
          file =>
            file.locations == null ||
            file.locations.length === 0 ||
            this.hasCommonElement(user.locations, file.locations)
        );
      }
      // Filter list files by languages
      if (!user.language) {
        listFiles = listFiles.filter(
          file => file.languages == null || file.languages.length === 0
        );
      } else {
        listFiles = listFiles.filter(
          file =>
            file.languages == null ||
            file.languages.length === 0 ||
            file.languages.includes(user.language)
        );
      }
      if (user.types == null || user.types.length === 0) {
        listFiles = listFiles.filter(
          file => file.types == null || file.types.length === 0
        );
      } else {
        // Accept case: user types is not empty, and type of file = empty
        listFiles = listFiles.filter(
          file => file.types == null || file.types.length === 0 ||
            this.hasCommonElement(user.types, file.types))
      }
      if (user.tags == null || user.tags.length === 0) {
        listFiles = listFiles.filter(
          file => file.tags == null || file.tags.length === 0
        );
      } else {
        // Accept case: user tags is not empty, and tag of file = empty
        listFiles = listFiles.filter(
          file =>
            file.tags == null || file.tags.length === 0 ||
            this.hasCommonElement(user.tags, file.tags)
        )
      }
      return listFiles;
    },
    // Job, client, candidate is optional
    // That is used for advance filter of email template of job type
    findEmailTemplatesByUserTypes(user, listTemplates, job, client, candidate) {
      console.log('111')
      if (listTemplates == null) {
        console.log('111')
        return null;
      }
      console.log('111')
      const listMatchingTemplates = this.filterTemplatesByUserTypes(
        user,
        listTemplates, job, client, candidate
      );
      console.log('111')
      // No matching
      if (!listMatchingTemplates || !listMatchingTemplates.length) {
        console.log('111')
        return null;
      }
      // Pick the one with highest matching index
      console.log('111')
      return listMatchingTemplates.reduce((prev, current) => {
        return prev.matchingIndex > current.matchingIndex ? prev : current;
      });
    },
    // Check if two array has at least 1 common element
    hasCommonElement(arr1, arr2) {
      if (arr1 == null || arr2 == null) {
        return false;
      }
      return arr1.some(r => arr2.includes(r));
    },
    downloadFile(fileURL, fileName) {
      // for non-IE
      if (!window.ActiveXObject) {
        var save = document.createElement("a");
        save.href = fileURL;
        save.target = "_blank";
        var filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
        save.download = fileName || filename;
        if (
          navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
          navigator.userAgent.search("Chrome") < 0
        ) {
          document.location = save.href;
          // window event not working here
        } else {
          var evt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: false
          });
          save.dispatchEvent(evt);
          (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
      }

      // for IE < 11
      else if (!!window.ActiveXObject && document.execCommand) {
        var _window = window.open(fileURL, "_blank");
        _window.document.close();
        _window.document.execCommand("SaveAs", true, fileName || fileURL);
        _window.close();
      }
    },
    // Copy content to clipboard
    copyContent(content) {
      const el = document.createElement("textarea");
      el.value = content;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    },
    sendPaymentSubmittedNotificationToAdmin(user) {
      return new Promise(async (resolve, reject) => {
        // Get the email template for the payment submitted notification
        let res = await this.getEmailTemplates(
          `/api/emailtemplates/?agency=${this.$store.getters.agencyID}&type=Payment Submitted Notification&selector1=Admin&deactivated=false`
        );
        if (res == null || res.data == null) {
          reject();
        }
        if (res.data.length) {
          // If there is an email template
          const excludeUserType = user.is_candidate ? "Client" : "Candidate";
          let emailTemplates = res.data;
          emailTemplates = emailTemplates.filter(
            template => template.selector3 !== excludeUserType
          );
          const emailTemplate = this.findEmailTemplatesByUserTypes(
            user,
            emailTemplates
          );

          if (emailTemplate) {
            const mapReplaceValues = {
              fname: user.first_name,
              lname: user.last_name,
              email: user.email,
              id: user.id
            };
            const subject = this.replaceTagByMap(
              emailTemplate.subject,
              mapReplaceValues
            );
            const message = this.replaceTagByMap(
              emailTemplate.body,
              mapReplaceValues
            );
            const emailObject = {
              subject: subject,
              message: message,
              file_urls: emailTemplate.attachment_urls,
              userID: user.id,
              from: this.getEmailSenderFromEmailTemplate(emailTemplate),
              reply: this.getReplyToFromEmailTemplate(emailTemplate),
              cc: emailTemplate.cc,
              bcc: emailTemplate.bcc,
              excludeFooter: emailTemplate.exclude_footer
            };
            // Send email without popup
            this.sendEmail({
              ...emailObject,
              recipients: [
                this.$store.getters.enginehireLoggingEmail,
                ...emailTemplate.destinations
              ],
              isHtml: true
            });
          }
        }
        resolve();
      });
    },
    sendUserStatusChangeNotificationSMS(user, status, isSecondStatus) {
      return new Promise(async (resolve, reject) => {
        if (!user.phone) {
          resolve();
        }
        const statusTriggerKey = isSecondStatus ? 'Second Status Change Notification' : 'Status Change Notification';

        await this.$store.dispatch('getStatusChangeSMSTemplate', {
          status: status,
          type: statusTriggerKey,
          user: user.is_candidate ? 'Candidate' : 'Client',
        })
        let initialSMSMessage = ''
        if (this.tryGet(() => this.$store.getters.statusChangeSMSTemplatesErrors.length)) {
          this.showErrorDialog({
            title: 'Error Loading SMS Templates, Please Try Again.',
          })
          reject();
        }
        let hasSMSDialog = false;
        if (user.phone && this.tryGet(() => this.$store.getters.statusChangeSMSTemplates.length)) {
          const mapReplacedValues = {
            '[[fname]]': user.first_name
          };
          initialSMSMessage = this.replaceAllByMap(
            this.$store.getters.statusChangeSMSTemplates[0].message,
            mapReplacedValues
          );
          initialSMSMessage = this.replaceTagValue(initialSMSMessage, user);
          if (this.$store.getters.isAgent) {
            hasSMSDialog = true;
            this.showInputDialog({
              title: "Send SMS Notification",
              listFields: [
                {
                  label: "Phone",
                  type: FORM_TYPE.LABEL,
                  model: user.phone
                },
                {
                  label: "Message",
                  type: FORM_TYPE.TEXTAREA,
                  model: "message",
                  isCounter: true
                },
              ],
              data: {
                message: initialSMSMessage
              },
              submitLabel: "Send",
              onSubmitCallback: async (SMSInfo) => {
                await axios.post("/optimum/message/", {
                  message: SMSInfo.message,
                  phone: user.phone,
                  user_id: user.id,
                  from_phone: this.$store.getters.agency.twilio_phone_number
                    ? this.$store.getters.agency.twilio_phone_number
                    : "",
                  agency_id: this.$store.getters.agencyID,
                  log: true
                });
              },
              onCloseCallback: () => {
                resolve();
              }
            });
          } else {
            await axios.post("/optimum/message/", {
              message: initialSMSMessage,
              phone: user.phone,
              user_id: user.id,
              from_phone: this.$store.getters.agency.twilio_phone_number
                ? this.$store.getters.agency.twilio_phone_number
                : "",
              agency_id: this.$store.getters.agencyID,
              log: true
            });
          }
        }
        if (!hasSMSDialog) {
          resolve();
        }
      });
    },
    showInputDialogSync(inputObj) {
      return new Promise(async (resolve) => {
        this.showInputDialog({
          ...inputObj,
          onSubmitCallback: (info) => {
            setTimeout(() => {
              resolve(info)
            }, 100);
          },
          onCloseCallback: () => {
            setTimeout(() => {
              resolve(null)
            }, 110);
          }
        });
      });

    },
    showConfirmDialogSync(confirmObj) {
      return new Promise(async (resolve) => {
        this.showConfirmDialog({
          ...confirmObj,
          onAcceptCallback: () => {
            setTimeout(() => {
              resolve(true)
            }, 0);
          },
          onRejectCallback: () => {
            setTimeout(() => {
              resolve(false);
            }, 0);
          }
        });
      });
    },
    validateBaseInputValues(applicationData, listFields) {
      return new Promise(async (resolve) => {
        const errorInfo = this.hasInvalidField(
          applicationData,
          listFields,
          this.$store.getters.isAgent
        );
        if (errorInfo) {
          this.showErrorDialog({
            key: "INVALID_INPUT_ERROR",
            params: [this.getErrorMessage(errorInfo)],
          });
          resolve(false);
          return;
        }
        resolve(true);
      });
    },
  }
});


// WEBPACK FOOTER //
// ./src/mixins/actions.js